import React, { memo } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';

import useLang from '../../hooks/useLang';

import Button from '../ui/Button';

import styles from './BackHeader.module.scss';

interface OwnProps {
  title: string;
  withBackButton?: boolean;
  withNotchOnScroll?: boolean;
  isScrolled?: boolean;
  onBackClick: NoneToVoidFunction;
  onTitleClick?: NoneToVoidFunction;
}

function BackHeader({
  title, withBackButton = true, withNotchOnScroll, isScrolled, onBackClick, onTitleClick,
}: OwnProps) {
  const lang = useLang();

  return (
    <div
      className={buildClassName(
        styles.root,
        withNotchOnScroll && 'with-notch-on-scroll',
        isScrolled && 'is-scrolled',
      )}
    >
      {withBackButton ? (
        <Button
          className={buildClassName(styles.backButton, withNotchOnScroll && styles.backButtonNoPadding)}
          isSimple
          isText
          onClick={onBackClick}
        >
          <i className={buildClassName(styles.backIcon, 'icon-chevron-left')} aria-hidden />
          <span>{lang('Back')}</span>
        </Button>
      ) : <div />}
      {onTitleClick ? (
        <button type="button" className={buildClassName(styles.title, styles.titleButton)} onClick={onTitleClick}>
          {title}
        </button>
      ) : <h3 className={styles.title}>{title}</h3>}
      <div />
    </div>
  );
}

export default memo(BackHeader);
